module.exports = __webpack_public_path__ + "static/media/photo-icon.c55183c6.svg";